/**
 * "Chụp bằng camera" under section 1's dropzone, in both modes (plan v4 web tăng cường mục 3). The dialog — and the
 * MediaPipe checks behind it — is loaded only when the button is pressed; the captured JPEG goes to `onPhoto`, the
 * same function a picked file goes to.
 */
import { Suspense, lazy, useId, useState } from "react";
import type { Spec } from "../api";
import { Modal } from "../components/Modal";
import type { CameraDialogProps } from "./CameraDialog";
import { CAMERA } from "./text";
import "./camera.css";

/** the dialog's chunk could not be fetched (offline, a new deploy): say so instead of breaking the page */
function DialogFailed({ onClose }: CameraDialogProps) {
  const titleId = useId();
  return (
    <Modal titleId={titleId} onClose={onClose}>
      <h2 id={titleId}>{CAMERA.title}</h2>
      <p role="alert" className="error">{CAMERA.dialogFailed}</p>
      <div className="actions actions-end">
        <button type="button" className="btn" onClick={onClose}>{CAMERA.close}</button>
      </div>
    </Modal>
  );
}

const CameraDialog = lazy(() => import("./CameraDialog").catch((e: unknown) => {
  console.warn("camera: the dialog did not load", e);
  return { default: DialogFailed };
}));

interface Props {
  onPhoto: (file: File) => void;
  /** the spec chosen in "Ảnh thẻ": the guide frames its photo and head height; none = a generic oval */
  spec?: Spec | null;
  disabled?: boolean;
}

export function CameraButton({ onPhoto, spec, disabled }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="btn btn-small camera-open" disabled={disabled} onClick={() => setOpen(true)}>
        {CAMERA.open}
      </button>
      {open && (
        <Suspense fallback={<p className="hint" aria-live="polite">{CAMERA.opening}</p>}>
          <CameraDialog spec={spec ?? null} onPhoto={onPhoto} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
